import React, { memo } from 'react';
import { isMobile } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { numPadTypes } from '../../../../enums';

export const BetAmountInput = memo(
  ({ handleChangeInputValue, handleChangeAmount, handleOpenNumPad, betAmount, isAutoBet }) => {
    const { minus, inputBlur, plus } = AdditionalInputValueChangingButtons;
    return (
      <div className='game-do-bet'>
        <div className='game-do-bet-btn  left' onClick={() => handleChangeInputValue(minus)}>
          <i className='ui-lib-minus' />
        </div>
        <input
          type='text'
          maxLength='9'
          disabled={isAutoBet}
          inputMode='none'
          className='game-do-bet-input type-1'
          value={betAmount}
          readOnly={isMobile()}
          onPaste={(e) => {
            e.preventDefault();
          }}
          onChange={handleChangeAmount}
          {...(isMobile()
            ? {
                onClick: (e) => handleOpenNumPad(e, numPadTypes.betAmount),
              }
            : {})}
          onBlur={() => handleChangeInputValue(inputBlur)}
        />
        <div className={`game-do-bet-btn right `} onClick={() => handleChangeInputValue(plus)}>
          <i className='ui-lib-plus' />
        </div>
      </div>
    );
  }
);
